import { render, staticRenderFns } from "./DownloadAreaAgree.vue?vue&type=template&id=28c62d56&scoped=true&lang=pug"
import script from "./DownloadAreaAgree.vue?vue&type=script&lang=js"
export * from "./DownloadAreaAgree.vue?vue&type=script&lang=js"
import style0 from "./DownloadAreaAgree.vue?vue&type=style&index=0&id=28c62d56&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c62d56",
  null
  
)

export default component.exports